import { Calendar, CalendarProps } from 'rsuite';

const SCalendar = (props: CalendarProps) => (
  <Calendar as={props.as} {...props} />
);

export default SCalendar;
